import React, { useState } from 'react';
import classnames from 'classnames';
import { NumberShim } from '@packages/helpers/core/shims/number-shim';
import { isUndefined } from '@packages/helpers/core/common';
import styles from '../../../styles/widgets/doughnuts/doughnuts.module.scss';
import { toMoneyStringWithComma } from '../../../helpers/formatters/money-format';
import { TickIcon } from '../../../icons/tick';
import { PieChart } from '../../../components/charts/pie-chart';

const Doughnut = React.memo(({ atid, value, target, sign, children, ariaLabel }) => {
  const [completed, setCompleted] = useState(false);

  return (
    <div className={styles.item} data-atid={atid}>
      {completed && (
        <div className={classnames(styles.sign, [styles[sign]])}>
          <div className={styles.tick}>
            <TickIcon />
          </div>
        </div>
      )}
      <PieChart
        className={styles.chart}
        value={NumberShim.percentOf(value, target)}
        onChange={setCompleted}
        target={target}
        ariaLabel={ariaLabel}
      >
        {children}
      </PieChart>
    </div>
  );
});

export const Doughnuts = React.memo(
  ({
    goals: { savePerMonth, monthlySaving, totalCosts, depositSavings, inTotalLowerValue, eachMonthLowerValue },
    totalHeading,
    monthlyHeading,
    emojiEnabled
  }) => (
    <div className={styles.container}>
      <div>
        {totalHeading && <p className={styles.heading}>{totalHeading}</p>}
        <Doughnut
          atid='in-total-doughnut'
          value={depositSavings}
          target={totalCosts}
          ariaLabel={totalHeading ?? 'Total'}
          sign='left'
        >
          <span className={styles.label}>{toMoneyStringWithComma(depositSavings)} of</span>
          <span className={styles.value}>{toMoneyStringWithComma(totalCosts)}</span>
          <span className={styles.suffix}>
            {inTotalLowerValue > 0 ? (
              `${toMoneyStringWithComma(inTotalLowerValue)} to go`
            ) : (
              <>
                {`${toMoneyStringWithComma(Math.abs(inTotalLowerValue))} extra`}
                {(isUndefined(emojiEnabled) || emojiEnabled) && (
                  <span role='img' aria-label='Flexed Biceps'>
                    &#128170;
                  </span>
                )}
              </>
            )}
          </span>
        </Doughnut>
      </div>
      <div>
        {monthlyHeading && <p className={styles.heading}>{monthlyHeading}</p>}
        <Doughnut
          atid='each-month-doughnut'
          value={monthlySaving}
          target={savePerMonth}
          ariaLabel={monthlyHeading ?? 'Monthly'}
          sign='right'
        >
          <span className={styles.label}>{toMoneyStringWithComma(monthlySaving)} of</span>
          <span className={styles.value}>{toMoneyStringWithComma(savePerMonth)} p/m</span>
          <span className={styles.suffix}>
            {eachMonthLowerValue > 0 ? (
              `${toMoneyStringWithComma(eachMonthLowerValue)} short`
            ) : (
              <>
                {`${toMoneyStringWithComma(Math.abs(eachMonthLowerValue))} spare`}
                {(isUndefined(emojiEnabled) || emojiEnabled) && (
                  <span role='img' aria-label='Thumbs Up'>
                    &#128077;
                  </span>
                )}
              </>
            )}
          </span>
        </Doughnut>
      </div>
    </div>
  )
);
